"use strict";

exports.__esModule = true;
exports.PlantStateActivitiesListView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _getStatesForActivity = require("../getStatesForActivity");
var _PlantStateActivitiesContext = require("../PlantStateActivitiesContext");
var _getFilteredPlantStateActivitiesList = require("../getFilteredPlantStateActivitiesList");
var _Core = require("../../Core");
var _PlantStateTag = require("../PlantStateTag");
var _System = require("../../../System");
var _dec, _class, _PlantStateActivitiesListView;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var TagList = _styledComponents["default"].span.withConfig({
  displayName: "PlantStateActivitiesListView__TagList",
  componentId: "sc-1263xfd-0"
})([".", "{margin-right:0.5rem;}"], _core.Classes.TAG);

/**
 * Renders Plant State Activities List View
 */
var PlantStateActivitiesListView = exports.PlantStateActivitiesListView = (_dec = _PlantStateActivitiesContext.PlantStateActivitiesContext.withContext, _dec(_class = (_PlantStateActivitiesListView = /*#__PURE__*/function (_Component) {
  function PlantStateActivitiesListView() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(PlantStateActivitiesListView, _Component);
  var _proto = PlantStateActivitiesListView.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      allPlantStateActivities = _this$props.plantStateActivities,
      enabledFilterOn = _this$props.enabledFilterOn;
    var plantStateActivities = Object.assign({}, allPlantStateActivities);
    var filteredActivities = plantStateActivities.activities.filter(function (activity) {
      return activity.isEnabled === enabledFilterOn;
    });
    plantStateActivities = Object.assign({}, plantStateActivities, {
      activities: filteredActivities
    });
    return /*#__PURE__*/_react["default"].createElement(_Core.ListView, null, (0, _getFilteredPlantStateActivitiesList.getFilteredPlantStateActivitiesList)(plantStateActivities).map(function (activity) {
      return activity.show && /*#__PURE__*/_react["default"].createElement(_Core.ListItemView, {
        key: activity.id
      }, /*#__PURE__*/_react["default"].createElement(_Core.ListItemViewLink, {
        to: (0, _System.getScreenURL)("UpdatePlantStateActivities", {
          id: activity.id
        })
      }, /*#__PURE__*/_react["default"].createElement(_Core.ListItemHeading, {
        level: 4
      }, activity.name), /*#__PURE__*/_react["default"].createElement(_Core.ListItemDescription, null, activity.description), /*#__PURE__*/_react["default"].createElement(TagList, {
        key: activity.id
      }, (0, _getStatesForActivity.getStatesForActivity)(activity.id, plantStateActivities).map(function (activityState) {
        return /*#__PURE__*/_react["default"].createElement(_PlantStateTag.PlantStateTag, {
          key: activityState.state.id,
          stateId: activityState.state.id,
          label: activityState.state.name
        });
      }))));
    }));
  };
  return PlantStateActivitiesListView;
}(_react.Component), _PlantStateActivitiesListView.defaultProps = {
  plantStateActivities: undefined
}, _PlantStateActivitiesListView)) || _class);